<mat-card
    class="ticket-card"
    [class.done]="ticket.done"
    [class.unassigned]="!ticket.assignedTo"
    [class.urgent-unassigned]="isUrgentUnassigned()"
>
    <!-- Priority Color Strip -->
    <div class="priority-strip" [style.background-color]="ticket.color" *ngIf="ticket.color"></div>

    <div class="ticket-content">
        <!-- Left Section: Compact Indicators -->
        <div class="ticket-left">
            <div class="ticket-number" [style.border-color]="getBackgroundColor()">#{{ ticket.ticketNo }}</div>

            <button
                mat-icon-button
                class="level-btn"
                (click)="setLevel()"
                [matTooltip]="'Level ' + (ticket.level || 1)"
            >
                <mat-icon class="level-icon" [class]="'level-' + (ticket.level || 1)">
                    {{ ticket.level === 2 ? 'looks_two' : 'looks_one' }}
                </mat-icon>
            </button>
        </div>

        <!-- Main Content -->
        <div class="ticket-main">
            <div class="ticket-row-1">
                <div class="ticket-title">{{ ticket.topic || 'Kein Betreff' }}</div>

                <div class="ticket-meta">
                    <span class="date">{{ ticket.createdAt | date : 'dd.MM.yyyy HH:mm' }}</span>
                    <span class="medium" *ngIf="ticket.medium">
                        <mat-icon>{{ getMediumIcon() }}</mat-icon>
                    </span>
                    <span class="last-reply" *ngIf="getLastReplyIcon()" [matTooltip]="getLastReplyTooltip()">
                        <mat-icon [class]="'reply-' + (ticket.lastAnswerBy || 'unknown')">{{
                            getLastReplyIcon()
                        }}</mat-icon>
                    </span>
                </div>
            </div>

            <div class="ticket-row-2">
                <div class="client">
                    <app-firmenname
                        *ngIf="ticket.clientId || ticket.leadId"
                        [isLead]="!!(!ticket.clientId && ticket.leadId)"
                        [clientId]="ticket.clientId || ticket.leadId"
                        [showNew]="true"
                    >
                    </app-firmenname>
                    <span *ngIf="!ticket.clientId && !ticket.leadId" class="no-contact">Kein Kontakt</span>
                </div>

                <div class="assignee" (click)="assignTicket()">
                    <mat-icon>person</mat-icon>
                    <span *ngIf="!ticket.assignedTo">Nicht zugeordnet</span>
                    <span *ngIf="ticket.assignedTo">{{
                        glo.getUserNameMitId(ticket.assignedTo || ticket.createdBy)
                    }}</span>
                </div>

                <div class="status" *ngIf="trelloCard.trelloListName || ticket.jiraStatusName">
                    <mat-chip>{{ trelloCard.trelloListName || ticket.jiraStatusName }}</mat-chip>
                </div>

                <div class="due-date" *ngIf="ticket.dueAt">
                    <mat-icon>event</mat-icon>
                    {{ ticket.dueAt | date : 'dd.MM' }}
                </div>
            </div>
        </div>

        <!-- Actions Section -->
        <div class="ticket-actions">
            <button
                mat-icon-button
                class="action-btn priority-btn"
                (click)="toggleColor()"
                [style.color]="ticket.color || '#999'"
                [matTooltip]="'Priorität: ' + (ticket.color || 'Keine')"
            >
                <mat-icon>circle</mat-icon>
            </button>

            <button
                mat-icon-button
                class="action-btn bookmark-btn"
                (click)="toggleBookmarkTicket()"
                [class.active]="ticket.bookmarked"
            >
                <mat-icon>{{ ticket.bookmarked ? 'bookmark' : 'bookmark_border' }}</mat-icon>
            </button>

            <button mat-icon-button class="action-btn close-btn" *ngIf="!ticket.done" (click)="closeTicket()">
                <mat-icon>check</mat-icon>
            </button>

            <button
                mat-icon-button
                class="action-btn edit-btn"
                [class.has-info]="ticket.info"
                [routerLink]="'/tickets/show/' + ticket.ticketId"
            >
                <mat-icon>{{ ticket.done ? 'visibility' : 'edit' }}</mat-icon>
            </button>
        </div>
    </div>
</mat-card>
